<template>
  <div v-bind="$attrs" class="my-3">
    <v-skeleton-loader type="text" width="25%"> </v-skeleton-loader>
    <v-skeleton-loader type="text"> </v-skeleton-loader>
  </div>
</template>

<script>
export default {}
</script>

<style>
</style>